import { createAction, props } from '@ngrx/store'
import { ReviewModel, RequestModel, ReviewPageRequestDescriptor } from '@models/index'

/**
 * Creates the action filterReviewsByLocation 
 * that searches the reviews that match widget settings.
 * Receives a {@link RequestModel}
 */
export const filterReviewsByLocation = createAction(
    '[Widgets Page] Filter Reviews By Location',
    props<{ request: RequestModel }>()
)

/**
 * Creates the action searchWidgetReviewsSuccess 
 * that stores the result returned of searching the reviews 
 * that match widget settings on the app state.
 * Receives a number and a {@link  ReviewModel}
 */
export const searchWidgetReviewsSuccess = createAction(
    '[Widgets Page] Search Reviews Success',
    props<{ total: number, data: ReviewModel[] }>()
)

/**
 * Creates the action getWidgetUrl that gets
 * the created widget URL.
 * Receives a {@link RequestModel}
 */
export const getWidgetUrl = createAction(
    '[Widgets Page] Get Widget Url',
    props<{ request: RequestModel }>()
)

/**
 * Creates the action getWidgetUrlSuccess that
 * stores the created widget URL on the app
 * state.
 * Receives a string
 */
export const getWidgetUrlSuccess = createAction(
    '[Widgets Page] Get Widget Url Success',
    props<{ widgetUrl: string }>()
)

/**
 * Creates the action getLoctionReviewsCount that
 * gets the total ammount of reviews that are 
 * associated to a specific location.
 * Receives a {@link RequestModel}
 */
export const getLoctionReviewsCount = createAction(
    '[Widgets Page] Get Location Reviews Count',
    props<{ request: RequestModel }>()
)

/**
 * Creates the action getLoctionReviewsCountSuccess
 * that stores the total ammount of reviews that are 
 * associated to a specific location on the app
 * state.
 * Receives a number
 */
export const getLoctionReviewsCountSuccess = createAction(
    '[Widgets Page] Get Location Reviews Count Success',
    props<{ reviewsCount: number }>()
)

/**
 * Creates the action getLoctionOverallRating that
 * gets the overall rating of the reviews that are 
 * associated to a specific location.
 * Receives a {@link RequestModel}
 */
export const getLoctionOverallRating = createAction(
    '[Widgets Page] Get Location Overall Rating',
    props<{ request: RequestModel }>()
)

/**
 * Creates the action getLoctionOverallRatingSuccess that
 * stores the overall rating of the reviews that are 
 * associated to a specific location on the app state.
 * Receives a number
 */
export const getLoctionOverallRatingSuccess = createAction(
    '[Widgets Page] Get Location Overall Rating Success',
    props<{ rating: number }>()
)

/**
 * Creates the action getLoctionStarsCount that
 * gets the stars distribution of the reviews 
 * that are associated to a location.
 * Receives a {@link RequestModel}
 */
export const getLoctionStarsCount = createAction(
    '[Widgets Page] Get Location Stars Count',
    props<{ request: RequestModel }>()
)

/**
 * Creates the action getLoctionStarsCountSuccess
 * that stores the stars distribution of the reviews 
 * that are associated to a location on the app state.
 * Receives a number
 */
export const getLoctionStarsCountSuccess = createAction(
    '[Widgets Page] Get Location Stars Count Success',
    props<{ starsCount: number[] }>()
)

/**
 * Creates the action getLoctionGenericLanding that
 * gets the generic landing URL of an specific location.
 * Receives a {@link RequestModel}
 */
export const getLoctionGenericLanding = createAction(
    '[Widgets Page] Get Location Generic Landing',
    props<{ request: RequestModel }>()
)

/**
 * Creates the action getLoctionGenericLandingSuccess 
 * that stores the generic landing URL of the selected
 * location on the app state.
 * Receives a string
 */
export const getLoctionGenericLandingSuccess = createAction(
    '[Widgets Page] Get Location Generic Landing Success',
    props<{ landing: string }>()
)

/**
 * Creates the action getLoctionGenericLandingSuccess 
 * that stores errors returned on a widget HTTP request.
 * Receives a string
 */
export const widgetError = createAction(
    '[Widgets Page] Widgets Error',    
    props<{ error: string }>()
)


export const getPagesIdWidgets = createAction(
    '[Widgets Page Page] Get Pages Id Widgets',
    props<{ request: RequestModel }>()
)

export const getPagesIdWidgetsSuccess = createAction(
    '[Widgets Page Page] Get Pages Id Widgets Success',
    props<{ data: ReviewPageRequestDescriptor[] }>()
)
